<div class="card">
    <h2>{{ 'courses.fieldset.assessment' | translate }}</h2>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <app-form-input [control]="form.controls.name" [label]="'courses.form.name' | translate" inputId="assessmentName" testId="courses-assessment-name" />

        <app-form-textarea
            [control]="form.controls.description"
            [label]="'courses.form.description' | translate"
            inputId="assessmentDescription"
            testId="courses-assessment-description"
        />

        <app-form-toggle-switch
            [control]="form.controls.showToAssessor"
            [label]="'courses.form.showToAssessor' | translate"
            [description]="'courses.form.showToAssessor.description' | translate"
            inputId="assessmentShowToAssessor"
            testId="courses-assessment-show-to-assessor"
        />

        <div class="actions">
            @if (assessment(); as assessment) {
                <p-button
                    [label]="'courses.assessment.delete' | translate"
                    icon="pi pi-trash"
                    severity="danger"
                    [outlined]="true"
                    [disabled]="saving()"
                    data-test="courses-assessment-delete"
                    (onClick)="onDelete()"
                />
            }
            <p-button
                type="submit"
                [label]="'courses.assessment.save' | translate"
                [outlined]="true"
                [disabled]="saving()"
                data-test="courses-assessment-save"
            />
        </div>
    </form>
</div>
